import React, {useState} from 'react'
import {Button} from 'react-bootstrap';
import {getComments} from "../../../firebase/getData";


export default function LoadComments(props) {
  const [noMore, setNoMore] = useState(false);

  const loadMore = () => {
    getComments({setState: props.setComments, postID: props.postID,
      lastComment: props.lastComment, setLastComment: props.setLastComment, 
      existingComments: props.comments, setNoMore});
  }

  return (
    <div className="text-center mb-4">
      <Button 
        variant={(noMore || props.comments.length < 5) ? "outline-danger" : "outline-success"} 
        disabled={(noMore || props.comments.length < 5) ? true : false} 
        onClick={loadMore}>
        {(noMore || props.comments.length < 5) ? 'All Comments Loaded' : 'Load More'}
      </Button>
    </div>
  )
}
